(function () {
  if (customElements.get('ep-video-carousel')) return;

  class EpVideoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-evc-track]');
      this.prevBtn = this.querySelector('[data-evc-prev]');
      this.nextBtn = this.querySelector('[data-evc-next]');
      if (!this.track) return;

      this.slides = Array.from(this.track.querySelectorAll('[data-evc-slide]'));
      if (this.slides.length === 0) return;

      // Open each video card in the shared modal (same logic as the other carousels).
      this.modal = this.querySelector('tb-video-modal');
      this.querySelectorAll('[data-evc-card]').forEach((card) => {
        card.addEventListener('click', () => {
          const url = card.dataset.videoUrl;
          if (url && this.modal && typeof this.modal.open === 'function') {
            this.modal.open(url, card);
          }
        });
      });

      this.prevBtn?.addEventListener('click', () => this.scrollByPage(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollByPage(1));

      // Update arrow disabled state on scroll.
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      this.updateArrows();
    }

    visibleCount() {
      const trackWidth = this.track.clientWidth;
      const slideWidth = this.slides[0]?.getBoundingClientRect().width || 1;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
      const perPage = Math.max(1, Math.round((trackWidth + gap) / (slideWidth + gap)));
      return perPage;
    }

    scrollByPage(direction) {
      const perPage = this.visibleCount();
      const slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
      const delta = (slideWidth + gap) * perPage * direction;
      this.track.scrollBy({ left: delta, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevBtn || !this.nextBtn) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      const left = this.track.scrollLeft;
      this.prevBtn.toggleAttribute('disabled', left <= 0);
      this.nextBtn.toggleAttribute('disabled', left >= max);
    }
  }

  customElements.define('ep-video-carousel', EpVideoCarousel);
})();
